import { requests } from '@/mixins/requests';

const PerksService = { getPerks: () => requests.getEntityItems({ key: 'OFFER_PERKS' }) };

export default PerksService;
